import { cn, type VariantProps } from 'noddi-ui-common';
import { Tabs as TabsPrimitive } from 'radix-ui';
import * as React from 'react';

import { selectionControlItemVariants, selectionControlListVariants } from './selectionControlVariants';

type TabsVariant = VariantProps<typeof selectionControlListVariants>['variant'];

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot='tabs' className={cn('flex flex-col gap-4', className)} {...props} />;
}

function TabsList({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & { variant?: TabsVariant }) {
  return (
    <TabsPrimitive.List
      data-slot='tabs-list'
      className={cn(selectionControlListVariants({ variant }), className)}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & { variant?: TabsVariant }) {
  return (
    <TabsPrimitive.Trigger
      data-slot='tabs-trigger'
      className={cn(selectionControlItemVariants({ variant }), className)}
      {...props}
    />
  );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content data-slot='tabs-content' className={cn('flex-1 outline-hidden', className)} {...props} />
  );
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
